// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".al-loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  color: var(--al-gray-500);\n  font-size: 0.875rem;\n}\n\n.al-loading-state--block  { height: 100%; }\n.al-loading-state--inline { padding: 2rem 0; gap: 0.5rem; }\n\n.al-loading-state-text { margin: 0; }\n", ""]);
// Exports
module.exports = exports;
